import React, { useEffect } from 'react';
import { useFeature } from 'flagged';
import { useAppDispatch, useTypedSelector } from 'combineReducers';
import { fetchOrganizationUserGroupsAndRolesIfNeeded } from '@pec/aion-ui-core/actions/organizationUserGroupsAndRoles';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';

export const ContractorAdministratorGuard: React.FC = ({ children }) => {
  const dispatch = useAppDispatch();
  const isBillingEnabled = useFeature('BillingIntegration');
  const { userInfo } = useTypedSelector(state => state.userInfo);
  const { organization } = useTypedSelector(state => state.organization);
  const { organizationUserGroupsAndRoles } = useTypedSelector(state => state.organizationUserGroupsAndRoles);
  const isExemptFromBillingOrg =
    (organization && organization.features.includes(OrganizationFeature.ExemptFromBilling)) ?? false;
  const billing = isBillingEnabled && !isExemptFromBillingOrg;

  const contractorAdministratorRoleID = process.env.REACT_APP_CONTRACTOR_ADMIN_ROLE_ID;
  const hasContractorAdminRole =
    organizationUserGroupsAndRoles &&
    organizationUserGroupsAndRoles.roles.some(role => role.id === contractorAdministratorRoleID);

  useEffect(() => {
    userInfo && dispatch(fetchOrganizationUserGroupsAndRolesIfNeeded(userInfo.primaryOrganizationId, userInfo.userId));
  }, [userInfo, dispatch]);

  if (hasContractorAdminRole && billing) {
    return <>{children}</>;
  } else return <></>;
};
